module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAExSURBVHgB7ZQ9TsNAEIVn1rig8xHCDXyFHIETxHQIGihAQWmJCKKAhogyOQFHgBvgG2BusBWN453MJini8e46sZQuT7Lkn/c+7c54B+CojbDNcHU3zlDRAAhSfkz40pzKyeB8+jKa7Q2+HD71IlN98m0K/nUVsVL9t8lDIb8oP9R8CahGhO+6k3ol+27YvxN4DaWamaH5AqOLptvCVzsLg21NJXQHpetcALxqVAfJXLMUFGpWQCLnqnEC3ZS0gTV0kw6DufuuFPFWlTGv4BGKXANMiHNPUisyf+CRETnnybu+f/wBeeIQZ/FpeVv+n/yC7ANi8f48OoPQiq0qFZ1bc+0lUeaDxqj6kuEEf/DZr6xZwpt/TG6hrlnRPt2G40wRDWhrutlG2ZpOJ/7pdtThtQQlrWq8CNgetwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/warning_icn.png
// module id = DLEg
// module chunks = 1